import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import './index.scss';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DataTable from '../../components/DataTable';
import PermissionsGate from '../../components/PermissionsGate';
import { SCOPES } from '../../helpers/permission-maps';
import Hero from '../../components/Hero';
import HeroImage from '../../assets/images/insightImage.svg';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';


const Insights = (props: any) => {
  const [uniqueEntityList, setUniqueEntityList] = useState<any[]>([]);
  const [selectedBusinessModelId, setSelectedBusinessModelId] = useState('');
  const [selectedChannelValue, setSelectedChannelValue] = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState('');

  const handleUniqueEntityList = (entityList) => {
    setUniqueEntityList(entityList);
  };

  const handleSelectedBusinessModelId = (businessModelId) => {
    setSelectedBusinessModelId(businessModelId);
  };

  const handleSelectedChannelValue = (channel) => {
    setSelectedChannelValue(channel);
  };

  const handleSelectedCategoryId = (categoryId) => {
    setSelectedCategoryId(categoryId);
  };

  let dateLimitMessage: string | null = null;

  if (selectedBusinessModelId) {
    if (selectedChannelValue && selectedBusinessModelId === '10001' && selectedCategoryId === '10003') {
      dateLimitMessage =
        'Please note that we have a limitation on historical data. You can select a From date at earliest one year back calculated from yesterday\'s date.';
    } else if (selectedBusinessModelId !== '10001' || selectedChannelValue) {
      dateLimitMessage =
        'Please note that we have a limitation on historical data. You can select a From date at earliest two years back calculated from yesterday\'s date.';
    }
  }


  return (
    <PermissionsGate redirect={true} scopes={[SCOPES.canAccessInsights]} canAccessInsights={true}>
      <div className="Insight Page-gradient">
        <Hero className="Hero Hero-gradient mb-5" heroImage={HeroImage}>
          <h1 className="Heading">Insights</h1>

          <p className="Hero-preamable mt-3">
            In this dashboard you can track the performance of your products online and in store.
          </p>
          {uniqueEntityList?.length > 1 && !selectedBusinessModelId ? (
            <ul>
              <li>Choose an entity.</li>
            </ul>
          ) : null}
          {selectedBusinessModelId == '10001' && !selectedChannelValue ? (
            <ul>
              <li>Choose a channel.</li>
            </ul>
          ) : null}
          {/* {selectedBusinessModelId === '10001' && selectedChannelValue =='1' ? (
            <p>
              Please note that data have a four day delay, hence you can only select from and to date at earliest four
              days back. Historical data retrieval is available from July 1st 2023 and onwards.{' '}
            </p>
          ) : null} */}
          {dateLimitMessage && <p>{dateLimitMessage}</p>}
          {selectedBusinessModelId &&
            (selectedBusinessModelId !== '10001' || selectedChannelValue) ? (
            <>
              <p>
                We advice you to interpret this as a high level overview. If you have any questions, contact{' '}
                <a href="mailto:partnersupport@hm.com"> partnersupport@hm.com</a>.{' '}
              </p>
              <ul>
                <li>Choose a From and To date for the period you wish to track.</li>
              </ul>
            </>
          ) : null}
        </Hero>
        <Container fluid="xl">
          <Row>
            <Col xs={12} sm={12} md={12}>
              <Tabs defaultActiveKey="Performance">
                <Tab eventKey="Performance" key="Performance" title="Performance">
                  <div className="users-table">
                    <Row>
                      <Col xs={12} sm={12} md={12}>
                        <DataTable
                          handleUniqueEntityList={handleUniqueEntityList}
                          handleSelectedBusinessModelId={handleSelectedBusinessModelId}
                          handleSelectedChannelValue={handleSelectedChannelValue}
                          handleSelectedCategoryId={handleSelectedCategoryId}
                        />
                      </Col>
                    </Row>
                  </div>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          <br />
        </Container>
      </div>
    </PermissionsGate>
  );
};

export default Insights;
